<template>
  <AppBtn icon="mdi:close" density="comfortable" :color="iconColor" borderless />
</template>

<script setup lang="ts">
defineProps<{
  iconColor?: string
}>();
</script>